export default __webpack_public_path__ + "static/media/logoHeader.97605922.svg";